import * as React from 'react';
import { styled } from 'styled-components';

const ParseContentWithBold = (text: string, textColor?: string) =>
	text.split(/(<b>.*?<\/b>)/g).map((part) =>
		part.startsWith('<b>') ? (
			<BoldText key={part} $textColor={textColor}>
				{part.slice(3, -4)}
			</BoldText>
		) : (
			part
		)
	);

export default ParseContentWithBold;

const BoldText = styled.span<{ $textColor?: string }>`
	font-weight: 600;
	color: ${(props) => props.$textColor || 'inherit'};
`;
